{
  "INBOX": {
    "LIST": {
      "TITLE": "My Inbox",
      "DISPLAY_DROPDOWN": "Display",
      "LOADING": "Értesítések lekérése",
      "404": "Ebben a csoportban nincsenek aktív értesítések.",
      "NO_NOTIFICATIONS": "No notifications",
      "NOTE": "Értesítés az összes feliratkozott postafiókból",
      "NO_MESSAGES_AVAILABLE": "Oops! Not able to fetch messages",
      "SNOOZED_UNTIL": "Halasztás eddig",
      "SNOOZED_UNTIL_TOMORROW": "Halasztás holnapig",
      "SNOOZED_UNTIL_NEXT_WEEK": "Halasztás jövő hétig"
    },
    "ACTION_HEADER": {
      "SNOOZE": "Értesítés alvó állapotban",
      "DELETE": "Értesítés törlése",
      "BACK": "Vissza"
    },
    "TYPES": {
      "CONVERSATION_MENTION": "Önt megemlítették egy beszélgetésben",
      "CONVERSATION_CREATION": "Új beszélgetés létrehozása",
      "CONVERSATION_ASSIGNMENT": "Egy beszélgetés hozzád lett rendelve",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Új üzenet egy kijelölt beszélgetésben",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Új üzenet egy beszélgetésben, amelyben részt vesz",
      "SLA_MISSED_FIRST_RESPONSE": "SLA target first response missed for conversation",
      "SLA_MISSED_NEXT_RESPONSE": "SLA target next response missed for conversation",
      "SLA_MISSED_RESOLUTION": "SLA target resolution missed for conversation"
    },
    "TYPES_NEXT": {
      "CONVERSATION_MENTION": "Mentioned",
      "CONVERSATION_ASSIGNMENT": "Assigned to you",
      "CONVERSATION_CREATION": "New Conversation",
      "SLA_MISSED_FIRST_RESPONSE": "SLA breach",
      "SLA_MISSED_NEXT_RESPONSE": "SLA breach",
      "SLA_MISSED_RESOLUTION": "SLA breach",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Új üzenet",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Új üzenet",
      "SNOOZED_UNTIL": "Snoozed for {time}",
      "SNOOZED_ENDS": "Snooze ended"
    },
    "NO_CONTENT": "Nincs elérhető tartalom",
    "MENU_ITEM": {
      "MARK_AS_READ": "Mark as read",
      "MARK_AS_UNREAD": "Megjelölés olvasatlanként",
      "SNOOZE": "Halasztás",
      "DELETE": "Törlés",
      "MARK_ALL_READ": "Mindent olvasottra állít",
      "DELETE_ALL": "Delete all",
      "DELETE_ALL_READ": "Delete all read"
    },
    "DISPLAY_MENU": {
      "SORT": "Rendezés",
      "DISPLAY": "Megjelenítés:",
      "SORT_OPTIONS": {
        "NEWEST": "Legújabb",
        "OLDEST": "Legrégibb",
        "PRIORITY": "Prioritás"
      },
      "DISPLAY_OPTIONS": {
        "SNOOZED": "Elnémított",
        "READ": "Olvasott",
        "LABELS": "Cimkék",
        "CONVERSATION_ID": "Beszélgetés azonosítója"
      }
    },
    "ALERTS": {
      "MARK_AS_READ": "Notification marked as read",
      "MARK_AS_UNREAD": "Notification marked as unread",
      "SNOOZE": "Notification snoozed",
      "DELETE": "Notification deleted",
      "MARK_ALL_READ": "All notifications marked as read",
      "DELETE_ALL": "All notifications deleted",
      "DELETE_ALL_READ": "All read notifications deleted"
    },
    "REAUTHORIZE": {
      "TITLE": "Reauthorization Required",
      "DESCRIPTION": "Your WhatsApp connection has expired. Please reconnect to continue receiving and sending messages.",
      "BUTTON_TEXT": "Reconnect WhatsApp",
      "LOADING_FACEBOOK": "Loading Facebook SDK...",
      "SUCCESS": "WhatsApp reconnected successfully",
      "ERROR": "Failed to reconnect WhatsApp. Please try again.",
      "WHATSAPP_APP_ID_MISSING": "WhatsApp App ID is not configured. Please contact your administrator.",
      "WHATSAPP_CONFIG_ID_MISSING": "WhatsApp Configuration ID is not configured. Please contact your administrator.",
      "CONFIGURATION_ERROR": "Configuration error occurred during reauthorization.",
      "FACEBOOK_LOAD_ERROR": "Failed to load Facebook SDK. Please try again.",
      "TROUBLESHOOTING": {
        "TITLE": "Troubleshooting",
        "POPUP_BLOCKED": "Ensure pop-ups are allowed for this site",
        "COOKIES": "Third-party cookies must be enabled",
        "ADMIN_ACCESS": "You need admin access to the WhatsApp Business Account"
      }
    }
  }
}
